// Copyright (c) 2021 WiseTime. All rights reserved.
import { useEffect } from "react"

export const useClickOutside = (
  node: HTMLElement | null,
  isVisible: boolean,
  callback: () => void, // callback should be constant
): void => {
  useEffect(() => {
    if (node === null) {
      return
    }
    const onClickOutside = (event: MouseEvent) => {
      if (node && !node.contains(event.target as Node)) {
        callback()
      }
    }
    if (isVisible) {
      document.addEventListener("click", onClickOutside, true)
    } else {
      document.removeEventListener("click", onClickOutside, true)
    }
    return () => {
      document.removeEventListener("click", onClickOutside, true)
    }
  }, [isVisible])
}
